<template>
    <div class="matter_new">
        <div :class="matter_new_top">
            <div class="sxlb_search">
                <input type="text" v-model="searchValue" placeholder="请输入查询内容…"/>
                <div @click="search">搜索</div>
            </div>
            <div>
                <van-tabs v-model="pcc" :sticky="true" @change="tabchange">
                    <van-tab v-for="(item,index) in policeTypeList" :title="item.value" :name="item.id" :key="index">
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <van-list class="list" v-model="loading" :finished="finished" finished-text="已加载全部" :error.sync="error"
                  error-text="请求失败，点击重新加载"
                  @load="loadMore">
            <div></div>
            <div :class="sxlb_ul" v-for="(item, index) in list" :key="index">
                <router-link v-if="item.reserveUrl!='WEIXIN'" :to="`/matterGuide/${item.pcc}/${item.guid}`"
                             @click.native="barpcc(item.pcc)">
                    <h1>{{ item.matName }}</h1>
                    <p>
                       <span class="qcwb" v-if="item.matProp=='1'"><i
                               class="qcwb_ico"></i>办理深度：全程网办</span>
                        <span class="qcwb" v-if="item.matProp=='2'"><i
                                class="qcwb_ico"></i>办理深度：在线预审</span>
                        <span class="qcwb" v-if="item.matProp=='3'"><i
                                class="qcwb_ico"></i>办理深度：在线预约</span>
                        <span class="qcwb" v-if="item.matProp=='4'"><i
                                class="qcwb_ico"></i>办理深度：办事指南</span>
                        <span class="qcwb" v-if="item.matProp=='5'"><i
                                class="qcwb_ico"></i>办理深度：事项公示</span>
                        <span class="qcwb" v-if="item.matProp=='6'"><i
                                class="qcwb_ico"></i>办理深度：其他</span>
                    </p>
                </router-link>
                <div v-else-if="item.reserveUrl=='WEIXIN'" @click="goshow(item)">
                    <h1>{{ item.matName }}</h1>
                    <p>
                        <span class="qcwb" v-if="item.matProp=='1'"><i
                                class="qcwb_ico"></i>办理深度：全程网办</span>
                        <span class="qcwb" v-if="item.matProp=='2'"><i
                                class="qcwb_ico"></i>办理深度：在线预审</span>
                        <span class="qcwb" v-if="item.matProp=='3'"><i
                                class="qcwb_ico"></i>办理深度：在线预约</span>
                        <span class="qcwb" v-if="item.matProp=='4'"><i
                                class="qcwb_ico"></i>办理深度：办事指南</span>
                        <span class="qcwb" v-if="item.matProp=='5'"><i
                                class="qcwb_ico"></i>办理深度：事项公示</span>
                        <span class="qcwb" v-if="item.matProp=='6'"><i
                                class="qcwb_ico"></i>办理深度：其他</span>
                    </p>
                </div>
                <div v-else @click="goUrl(item.applyUrl)" @click.native="barpcc(item.pcc)">
                    <h1>{{ item.matName }}</h1>
                    <p>
                        <span class="qcwb" v-if="item.matProp=='1'"><i
                                class="qcwb_ico"></i>办理深度：全程网办</span>
                        <span class="qcwb" v-if="item.matProp=='2'"><i
                                class="qcwb_ico"></i>办理深度：在线预审</span>
                        <span class="qcwb" v-if="item.matProp=='3'"><i
                                class="qcwb_ico"></i>办理深度：在线预约</span>
                        <span class="qcwb" v-if="item.matProp=='4'"><i
                                class="qcwb_ico"></i>办理深度：办事指南</span>
                        <span class="qcwb" v-if="item.matProp=='5'"><i
                                class="qcwb_ico"></i>办理深度：事项公示</span>
                        <span class="qcwb" v-if="item.matProp=='6'"><i
                                class="qcwb_ico"></i>办理深度：其他</span>
                    </p>
                </div>
            </div>
        </van-list>
        <new-floor v-if="this.isShowTabbar=='WEI'"></new-floor>
    </div>
</template>

<script>
    import {TabbarItem, Dialog, Toast, Tab, Tabs, List} from 'vant'

    import getSource from '../../../assets/js/public/Device'
    import {matterApiMap} from '@/api/matter'
    import NewFloor from '../../../components/floor/NewFloor.vue'
    import { Source } from '@/utils/source'

    export default {
        components: {
            [TabbarItem.name]: TabbarItem,
            [Dialog.name]: Dialog,
            [Toast.name]: Toast,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List,
            NewFloor
        },
        data() {
            return {
                ps: 10, // 每页展示的个数
                pi: 1,
                total: '',
                list: [], // 存放列表详情
                pcc: '', // 存放警种id
                typeId: '', // 分组groupid
                searchValue: '', // 搜索框内容
                num: 0, // 控制第二次点击弹出事项分类
                matter_new_top: 'matter_new_top',
                sxlb_ul: 'sxlb_ul',
                showMessage: false,
                policeTypeList: [],
                active: this.$route.query.source,
                loading: false, // 是否显示加载loading图标
                finished: false, // 控制"没有更多了"的显示与隐藏
                error: false, // 控制访问接口异常情况下，可以再次重新访问接口
                isShowTabbar: '' //显示隐藏tabbar
            }
        },
        created() {
            this.showMessage = false
            if (getSource() === "WEI") {
                this.matter_new_top = 'matter_new_top'
                this.sxlb_ul = 'sxlb_ul'
            } else if (getSource() == "IOS") {
                this.matter_new_top = 'ios_matter_new_top'
                this.sxlb_ul = 'ios_sxlb_ul'
            } else if (getSource() == "ANDROID") {
                this.matter_new_top = 'matter_new_top'
                this.sxlb_ul = 'sxlb_ul'
            }

            // 判断设备
            this.isShowTabbar = Source.getSource()
        },
        mounted() {
            this.getPccsList();
            // 初始化警种
            // // 首次进入页面判断是否需要tab切换
            // this.chooseTab()
        },
        activated() {
            const jump = window.sessionStorage.getItem('matterJump')
            // 点击跳入
            if(jump === 'Y') {
                // 切换tab页状态
                this.chooseTab()
            }
            // 切换后清除状态
            window.sessionStorage.removeItem("matterJump");
        },
        methods: {
            /**
             * 点击时的tab
             */
            chooseTab() {
                let windowTitle = "全部"
                if(this.$route.query.pcc){
                    this.pcc = this.$route.query.pcc
                    this.typeId = this.$route.query.guid;
                    windowTitle = this.$route.query.alt
                    this.search()
                }else{
                    this.pcc = '';
                    this.typeId = '';
                    this.search()
                    window.document.title = windowTitle;
                }
            },
            goshow(item) {
                // this.$router.push('/matter/detail/jz/' + item.pcc + '/' + item.guid)
                this.$router.push(`/matterGuide/${item.pcc}/${item.guid}`)
            },
            //储存预约的警种
            barpcc(res) {
                if (res == "1") {
                    this.$store.state.revertionpcc = res
                }
            },
            tabchange(name, title) {
                this.pcc = name == '0' ? '' : name;
                this.ps = 10;
                this.search();
            },
            // 搜索/matterNew
            async search() {

                // 列表接口
                // this.ps += 10
                const data = {
                    ps: this.ps,
                    pi: 1,
                    kw: this.searchValue,
                    caseType: this.caseType,
                    pcc: this.pcc == '0' ? '' : this.pcc,
                    typeId: this.typeId,
                    free: this.free ? 'Y' : '',
                    onlineDone: this.onlineDone ? 'Y' : '',
                    onlinnAppointment: this.onlinnAppointment ? 'Y' : ''
                }
                try {
                    const res = await this.$httpUtils.getCommonUtils(matterApiMap.matterPage, data)
                    this.list = res.data.data.list
                    this.total = res.data.data.totalRow
                    this.loading = false
                    if (this.ps >= res.data.data.totalRow) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                } catch (error) {
                    this.error = true
                    this.loading = false
                    console.log(error)
                }
            },

            // 加载更多
            async loadMore() {
                this.ps += 5
                this.search()
            },
            // 公示
            goUrl: function (url) {
                window.location.assign(url)
            },

            async getPccsList() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(matterApiMap.pccs);
                    let list = [{id: '', value: '全部'}];
                    res.data.data.forEach((data, index, arr) => {
                        list.push({id: data.id, value: data.value});
                    });
                    this.policeTypeList = list;
                } catch (error) {
                    console.log(error)
                }
            }
        }
    }
</script>
<style>
    .matter_new .van-tabs__line {
        background-color: #1989fa;
    }
</style>
<style lang="less" scoped>
    @import "~@assets/css/views/matter/list/MatterListNew";
</style>


